// :cow: Cosmose CONFIDENTIAL :iso:
import { PlannerFullDemoStepEnum } from '@med/app/home/planner-full-demo/planner-full-demo-step.enum';

export const plannerFullDemoStepOrder = [
  PlannerFullDemoStepEnum.campaignListAddNewCampaign,
  PlannerFullDemoStepEnum.campaignObjectiveSelectNewStoreOpening,
  PlannerFullDemoStepEnum.plannerStartSelectAudience,
  PlannerFullDemoStepEnum.audienceShowEstimates,
  PlannerFullDemoStepEnum.audienceReadSegmentDescriptions,
  PlannerFullDemoStepEnum.audienceSelectCompetitors,
  PlannerFullDemoStepEnum.audienceShowEstimatesChange,
  PlannerFullDemoStepEnum.audienceSelectLocationCategories,
  PlannerFullDemoStepEnum.audienceExplainAddingLocationCategories,
  PlannerFullDemoStepEnum.audienceAskToSelectCity,
  PlannerFullDemoStepEnum.audienceShowTimespan,
  PlannerFullDemoStepEnum.audienceAskToClickContinue,
  PlannerFullDemoStepEnum.demographicsSelectGender,
  PlannerFullDemoStepEnum.demographicsAskToClickContinue,
  PlannerFullDemoStepEnum.budgetSelectCampaignDuration,
  PlannerFullDemoStepEnum.budgetCalculationExplanation,
  PlannerFullDemoStepEnum.budgetAskToClickContinue,
  PlannerFullDemoStepEnum.mediaSearchPlatform,
  PlannerFullDemoStepEnum.mediaSelectFormat,
  PlannerFullDemoStepEnum.mediaAskToClickContinue,
  PlannerFullDemoStepEnum.spotplanAnalyze,
  PlannerFullDemoStepEnum.spotplanAskToClickSummary,
  PlannerFullDemoStepEnum.summaryAskToClickSendForReview,
  PlannerFullDemoStepEnum.sentForReviewAskToClickBackToDashboard,
  PlannerFullDemoStepEnum.campaignListExposeCampaign,
];
